import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { page, menulist } from '../class/status';
import { chartdata } from '../class/chatdata';
import * as Highcharts from 'highcharts';
import { Options } from 'highcharts';
import * as moment from 'moment';
import { EVENT_LABEL, PAGE_LABEL, KIND_LABEL, eventKind } from './event-labels';

@Component({
    selector: 'app-user-behavior',
    templateUrl: './user-behavior.component.html',
    styleUrls: ['./user-behavior.component.css']
})
export class UserBehaviorComponent implements OnInit {

    Highcharts: typeof Highcharts = Highcharts;

    // 兩張圖各自深拷貝一份。chartdata.line 是 static 共用物件,直接指派再改會污染其他分析頁。
    // 另外 JSON 深拷貝會丟掉函式(tooltip.formatter / dataLabels.formatter 都是函式),
    // 所以拷貝後必須自己把要的行為補回來 —— 見 init_chart_options()。
    eventChart: Options = JSON.parse(JSON.stringify(chartdata.line));
    userChart: Options = JSON.parse(JSON.stringify(chartdata.line));
    eventUpdate = false;
    userUpdate = false;

    loading = true;
    now = '0';
    menu_list: menulist = [
        { id: '0', name: '用戶整體行為' },
        { id: '1', name: '個別用戶行為' },
    ];

    // ---- 整體 ----
    time: any = {};
    ranges: any = {
        '今天': [moment(), moment()],
        '昨天': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        '過去一周': [moment().subtract(6, 'days'), moment()],
        '過去30天': [moment().subtract(29, 'days'), moment()],
        '本月': [moment().startOf('month'), moment().endOf('month')],
    };
    page_filter = '-1';
    page_options: menulist = [{ id: '-1', name: '全部頁面' }];
    data: any = [];
    page_list: any = [];
    page_groups: any = [];   // 「進入 → 頁內做了什麼」分組(與儲值路徑同一種讀法)
    open_group: any = {};
    funnel: any = [];
    summary: any = {};
    truncated = false;
    load_error = '';
    pageobj: page = { page: 0, count: 20, total_count: 0 };
    pageobjstr: string = JSON.parse(JSON.stringify(this.pageobj));
    sort_obj: any = { column: 'cnt', sort: '1' };

    // ---- 個別用戶 ----
    find_mode: 'direct' | 'tag' = 'direct';   // 查詢面板目前顯示哪一種找人方式
    search_model = '';
    user: any = null;
    batches: any = [];
    user_events: any = [];
    user_pages: any = [];
    user_summary: any = {};
    user_msg = '';
    match_by = '';
    open_batch: any = {};

    // ---- 說明面板與頁面熱度排序 ----
    show_help = false;
    page_sort: any = { col: 'cnt', desc: true };

    // ---- Tag 找人(與「用戶列表」頁同一套 Tag 資料) ----
    // app-tagselect 自己撈 /tag_list.php,吐出 groupTagArr(依 tag 類型分組的名稱陣列),
    // 再丟給 /v1/common/get_user_list.php 過濾 —— 與用戶列表頁走同一條路,不另寫 tag 邏輯。
    groupTagArr: any = [];
    tag_time = '7';
    tag_time_list: menulist = [
        { id: '7', name: '過去7天' },
        { id: '1', name: '昨天' },
        { id: '30', name: '過去30天' },
        { id: 'm1', name: '上個月' },
        { id: 'm2', name: '上上個月' },
    ];
    tag_users: any = [];
    tag_msg = '';
    tag_update_dt = '';
    tag_pageobj: page = { page: 0, count: 10, total_count: 0 };
    tag_pageobjstr: string = JSON.parse(JSON.stringify(this.tag_pageobj));

    tcontent = [
        { title: '事件', content: 'event', type: 3, css: 'min-width: 260px;' },
        { title: '所屬頁面', content: 'page', type: 3, css: 'min-width: 130px;' },
        { title: '類型', content: 'kind', type: 3, css: 'min-width: 90px;' },
        { title: '次數', content: 'cnt', sort: 'cnt', format: 'number', css: 'min-width: 90px;' },
        { title: '人數', content: 'uv', sort: 'uv', format: 'number', css: 'min-width: 90px;' },
        { title: '佔比', content: 'pct', type: 3, css: 'min-width: 90px;' },
    ];

    user_tcontent = [
        { title: '事件', content: 'event', type: 3, css: 'min-width: 260px;' },
        { title: '所屬頁面', content: 'page', type: 3, css: 'min-width: 130px;' },
        { title: '次數', content: 'cnt', format: 'number', css: 'min-width: 90px;' },
        { title: '佔比', content: 'pct', type: 3, css: 'min-width: 90px;' },
    ];

    constructor(public httpClient: HttpClient) { }

    ngOnInit(): void {
        this.init_chart_options();
        this.init_time();
    }

    // ---------- 顯示用轉換 ----------

    /** 事件的中文說明。查不到就退回原始英文字串 —— App 新增而對照表還沒補時,資料照樣看得到。 */
    eventLabel(event: string): string {
        return EVENT_LABEL[event] || '';
    }

    pageLabel(pageCode: string): string {
        return PAGE_LABEL[pageCode] || pageCode;
    }

    kindOf(event: string): string {
        return eventKind(event);
    }

    kindLabel(event: string): string {
        return KIND_LABEL[eventKind(event)] || '其他';
    }

    // ---------- 圖表 ----------

    init_chart_options(): void {
        [this.eventChart, this.userChart].forEach((opt: any) => {
            opt.chart = { type: 'line', height: 260 };
            opt.subtitle = { text: '' };
            // 單一序列不需要圖例(標題已經說明是什麼),留著只會佔版面
            opt.legend = { enabled: false };
            opt.credits = { enabled: false };
            // 千分位:y 軸刻度與 tooltip 都要。tiles/表格走 Angular 的 number pipe,
            // 圖表是 Highcharts 自己渲染,得用它的 numberFormat 各自處理。
            opt.yAxis = {
                title: { text: '' }, allowDecimals: false,
                labels: {
                    formatter: function (this: any) {
                        return Highcharts.numberFormat(this.value, 0, '.', ',');
                    }
                }
            };
            // 深拷貝丟失 formatter 後 dataLabels 仍是 enabled:true,30 天區間會擠成一團 —— 關掉,改靠 tooltip
            opt.plotOptions = {
                line: {
                    dataLabels: { enabled: false },
                    marker: { enabled: true, radius: 4 },
                    lineWidth: 2,
                }
            };
            opt.tooltip = {
                shared: true,
                formatter: function (this: any) {
                    const pts = this.points || [this.point];
                    let s = '<b>' + this.x + '</b>';
                    pts.forEach((p: any) => {
                        s += '<br>' + p.series.name + ': <b>' + Highcharts.numberFormat(p.y, 0, '.', ',') + '</b>';
                    });
                    return s;
                }
            };
        });
        this.eventChart.title = { text: '每日事件次數' };
        this.userChart.title = { text: '每日活躍用戶數' };
    }

    draw_chart(res: any): void {
        const categories = res.categories || [];
        const series = res.series || [];
        // 事件次數與活躍用戶量級差一個數量級(數千 vs 數百),硬畫在同一張圖會把用戶數壓成平線,
        // 而雙 y 軸會讓兩條線的相對高低變成任意的視覺假象 —— 拆成兩張各自單一序列的圖。
        (this.eventChart as any).xAxis = { categories: categories };
        (this.eventChart as any).series = [{
            name: '事件次數', type: 'line',
            data: series[0] ? series[0].data : []
        }];
        (this.userChart as any).xAxis = { categories: categories };
        (this.userChart as any).series = [{
            name: '活躍用戶', type: 'line',
            data: series[1] ? series[1].data : []
        }];
        this.eventUpdate = true;
        this.userUpdate = true;
    }

    // ---------- 分頁切換 ----------

    choosetag(id: string): void {
        this.now = id;
        if (id === '0' && this.data.length === 0) {
            this.init_list();
        }
    }

    // ---------- 整體行為 ----------

    init_time(): void {
        this.time.minDate = moment().subtract(180, 'days');
        this.time.maxDate = moment();
        this.time.startDate = moment().subtract(6, 'days');
        this.time.endDate = moment();
        this.time.start = moment(this.time.startDate).format('YYYY-MM-DD');
        this.time.end = moment(this.time.endDate).format('YYYY-MM-DD');
        this.init_list();
    }

    onRangeSelected(value: any): void {
        if (!value || !value.startDate) { return; }
        this.pageobj = { page: 0, count: this.pageobj.count, total_count: 0 };
        this.time.start = moment(value.startDate).format('YYYY-MM-DD');
        this.time.end = moment(value.endDate).format('YYYY-MM-DD');
        this.init_list();
    }

    handlesortdata(value: any): void {
        this.sort_obj = value;
        this.pageobj.page = 0;
        this.init_list();
    }

    changePageFilter(): void {
        this.pageobj = { page: 0, count: this.pageobj.count, total_count: 0 };
        this.init_list();
    }

    init_list(): void {
        this.loading = true;
        this.load_error = '';
        const body = {
            act: '1',
            page: this.pageobj.page,
            count: this.pageobj.count,
            now_range: { start: this.time.start, end: this.time.end },
            page_filter: this.page_filter,
            sort_obj: this.sort_obj,
        };
        this.httpClient.post<any>('/v1/data_analyze/get_user_behavior.php', body).subscribe(res => {
            this.loading = false;
            if (res && res.status) {
                this.data = res.data || [];
                this.page_list = res.page_list || [];
                this.page_groups = res.page_groups || [];
                this.apply_page_sort();
                // 預設展開活動量最高的那一頁,讓人一進來就看得到「這種讀法長什麼樣」
                this.open_group = {};
                if (this.page_groups.length > 0) { this.open_group[this.page_groups[0].page] = true; }
                this.funnel = res.funnel || [];
                this.summary = res.summary || {};
                this.truncated = !!res.truncated;
                this.pageobj.total_count = res.total_count || 0;
                this.build_page_options();
                this.draw_chart(res);
            } else {
                this.data = [];
                this.page_list = [];
                this.page_groups = [];
                this.funnel = [];
                this.summary = {};
                this.truncated = false;
                this.pageobj.total_count = 0;
            }
            this.pageobjstr = JSON.parse(JSON.stringify(this.pageobj));
        }, error => {
            // ⚠ 一定要有 error callback。spinner 的遮罩是 position:fixed 全螢幕、z-index 一百萬、
            // 沒有 pointer-events:none,而攔截器的 catchError 是直接 rethrow、不會幫忙關 loading。
            // 少了這段,API 一旦 500/逾時,loading 永遠停在 true → 整個後台被遮罩鎖住
            // (連左側選單都點不到),只能 F5。而且首次進頁就會打這支 API。
            this.loading = false;
            this.data = [];
            this.page_list = [];
            this.funnel = [];
            this.summary = {};
            this.truncated = false;
            this.pageobj.total_count = 0;
            this.pageobjstr = JSON.parse(JSON.stringify(this.pageobj));
            this.load_error = '查詢失敗，請稍後再試或縮小日期範圍';
            console.log(error);
        });
    }

    /** 頁面下拉選項由實際資料產生,不寫死 —— 沒有資料的頁面不會出現在選單裡。
     *  已選中的頁面即使因為篩選後 page_list 只剩它自己,也不會從選單消失。 */
    build_page_options(): void {
        if (this.page_filter !== '-1') { return; }
        const opts: menulist = [{ id: '-1', name: '全部頁面' }];
        this.page_list.forEach((p: any) => {
            opts.push({ id: p.page, name: this.pageLabel(p.page) });
        });
        this.page_options = opts;
    }

    callback(pageobj: page): void {
        if (JSON.stringify(this.pageobj) !== JSON.stringify(pageobj)) {
            this.pageobj = pageobj;
            this.init_list();
        }
    }

    // ---------- 個別用戶 ----------

    /** @param scroll_to_result 從 Tag 名單點「查看行為」時為 true:結果區在名單下方很遠,查完自動捲過去 */
    search_user(scroll_to_result: boolean = false): void {
        if (!this.search_model || this.search_model.trim() === '') {
            this.user_msg = '請輸入用戶 uid / 暱稱 / 手機';
            return;
        }
        this.loading = true;
        this.user_msg = '';
        const body = { act: '2', search: this.search_model.trim(), count: 50 };
        this.httpClient.post<any>('/v1/data_analyze/get_user_behavior.php', body).subscribe(res => {
            this.loading = false;
            if (res && res.status) {
                this.user = res.user;
                this.match_by = res.match_by || '';
                this.batches = res.batches || [];
                this.user_events = res.data || [];
                this.user_pages = res.page_list || [];
                this.user_summary = res.summary || {};
                this.open_batch = {};
                if (this.batches.length === 0) {
                    this.user_msg = '這位用戶目前沒有任何行為埋點紀錄(App 端可能尚未上傳,或使用的版本還沒有埋點)';
                }
                if (scroll_to_result) { this.scroll_to('ub-user-result'); }
            } else {
                this.user = null;
                this.batches = [];
                this.user_events = [];
                this.user_pages = [];
                this.user_summary = {};
                this.user_msg = (res && res.msg) ? res.msg : '查詢失敗';
            }
        }, error => {
            this.loading = false;   // 同上:沒有這段會被全螢幕遮罩鎖死
            this.user = null;
            this.batches = [];
            this.user_events = [];
            this.user_pages = [];
            this.user_summary = {};
            this.user_msg = '查詢失敗，請稍後再試';
            console.log(error);
        });
    }

    toggle_batch(id: any): void {
        this.open_batch[id] = !this.open_batch[id];
    }

    // ---------- 頁面熱度排序 ----------

    sortPageBy(col: string): void {
        if (this.page_sort.col === col) {
            this.page_sort.desc = !this.page_sort.desc;
        } else {
            this.page_sort = { col: col, desc: true };
        }
        this.apply_page_sort();
    }

    apply_page_sort(): void {
        const c = this.page_sort.col;
        const d = this.page_sort.desc ? -1 : 1;
        this.page_groups.sort((a: any, b: any) => {
            if (a[c] !== b[c]) { return (a[c] < b[c] ? -1 : 1) * d; }
            return a.page < b.page ? -1 : 1;   // 並列時固定用頁面代碼,順序才不會跳
        });
    }

    toggle_group(page: string): void {
        this.open_group[page] = !this.open_group[page];
    }

    /** 長條寬度上限 100(pct 本身可能 >100:App 從背景回前景不重記「進入」),數字照實顯示 */
    barWidth(pct: any): number {
        const n = Number(pct) || 0;
        return n > 100 ? 100 : n;
    }

    // ---------- Tag 找人 ----------

    calltagList(event: any): void {
        this.groupTagArr = event;
    }

    /** Tag 快照是排程定期產生的,查詢時要指定「取哪段期間的快照」——
     *  這個時間指的是快照的產生時間,不是用戶的行為時間。預設過去 7 天,涵蓋最新一批快照。 */
    private tagRange(): { start: string, end: string } {
        switch (this.tag_time) {
            case '1':
                return { start: moment().subtract(1, 'days').format('YYYY-MM-DD'), end: moment().subtract(1, 'days').format('YYYY-MM-DD') };
            case '30':
                return { start: moment().subtract(30, 'days').format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD') };
            case 'm1':
                return { start: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'), end: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD') };
            case 'm2':
                return { start: moment().subtract(2, 'month').startOf('month').format('YYYY-MM-DD'), end: moment().subtract(2, 'month').endOf('month').format('YYYY-MM-DD') };
            default:
                return { start: moment().subtract(7, 'days').format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD') };
        }
    }

    search_by_tag(reset: boolean): void {
        const picked: any = [];
        (this.groupTagArr || []).forEach((arr: any) => {
            (arr || []).forEach((t: any) => picked.push(t));
        });
        if (picked.length === 0) {
            this.tag_msg = '請先選擇至少一個 Tag';
            return;
        }
        if (reset) {
            this.tag_pageobj = { page: 0, count: this.tag_pageobj.count, total_count: 0 };
        }
        this.loading = true;
        this.tag_msg = '';
        // 與「用戶列表」頁同一支 API、同一組預設參數(country 放寬為全部,免得外國用戶被藏掉),
        // Tag 過濾語意完全一致。skip_taglist=1:tag 清單由 app-tagselect 自己撈,這裡不用後端重算。
        const body = {
            page: this.tag_pageobj.page,
            count: this.tag_pageobj.count,
            tool: {
                groupTag: [], tag: '-2', search_model: '', search_gender: '-1', vender: '0',
                search_country: '-1', filter_status: '-1', is_enable: '1',
                filter_money_num: 0, filter_num: 0, sms_contnt: '', track: '0', profile_menu: '0'
            },
            sort_obj: { column: 'create_dt', sort: '0' },
            groupTag: this.groupTagArr,
            now: '0',
            search_date_user: '0',
            Usertime: this.tagRange(),
            LastUsertime: { start: '', end: '' },
            skip_taglist: 1,
        };
        this.httpClient.post<any>('/v1/common/get_user_list.php', body).subscribe(res => {
            this.loading = false;
            if (res && res.status) {
                // ⚠ 後端在統計時間內找不到 Tag 快照時「不會套用過濾」,回來的是全部用戶。
                //   tagupdate_dt 為空就是這個訊號 —— 這種結果會誤導(把全站用戶當成 Tag 成員),直接擋下。
                if (!res.tagupdate_dt) {
                    this.tag_users = [];
                    this.tag_pageobj.total_count = 0;
                    this.tag_msg = '這個統計時間內沒有這些 Tag 的資料快照，請換一個統計時間試試（Tag 快照由排程定期產生）';
                } else {
                    this.tag_users = res.data || [];
                    this.tag_update_dt = res.tagupdate_dt;
                    this.tag_pageobj.total_count = res.total_count || 0;
                    if (this.tag_users.length === 0) { this.tag_msg = '沒有符合這些 Tag 的用戶'; }
                }
            } else {
                this.tag_users = [];
                this.tag_pageobj.total_count = 0;
                this.tag_msg = '查詢失敗';
            }
            this.tag_pageobjstr = JSON.parse(JSON.stringify(this.tag_pageobj));
        }, error => {
            this.loading = false;   // 同 init_list:少了這段會被全螢幕遮罩鎖死
            this.tag_msg = '查詢失敗，請稍後再試';
            console.log(error);
        });
    }

    tag_callback(pageobj: page): void {
        if (JSON.stringify(this.tag_pageobj) !== JSON.stringify(pageobj)) {
            this.tag_pageobj = pageobj;
            this.search_by_tag(false);
        }
    }

    /** 從 Tag 搜尋結果點一個人 → 帶入查詢框、直接查他的行為,查完捲到結果區 */
    pick_tag_user(u: any): void {
        this.search_model = u.uid;
        this.search_user(true);
    }

    // ---------- 錨點捲動 ----------

    /** 捲到頁面上的錨點。結果區是 *ngIf,要等這一輪變更偵測把它畫出來才抓得到 → 包在 setTimeout 裡 */
    private scroll_to(id: string): void {
        setTimeout(() => {
            const el = document.getElementById(id);
            if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        }, 0);
    }

    back_to_search(): void {
        this.scroll_to('ub-search-panel');
    }
}
